import { useCallback } from 'react';

import { useStoreContext } from 'features/store';

import usePosVendor from 'hooks/menu/use-pos-vendor';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { SanitySystemwideOffer, SanitySystemwideTierGroup } from 'state/loyalty/types';
import { useDerivedServiceModeContext } from 'state/service-mode/derived';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

import { processTierGroup_Legacy } from './legacy';
import { processTierGroup_UnifiedMenu } from './one-menu';

export function useTierGroupProcessor() {
  const { prices } = useStoreContext();
  const { vendor } = usePosVendor();
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();
  const { indexedMenu, isLoading: isLoadingIndexedMenu } = useUnifiedMenuContext();
  const { posServiceMode } = useDerivedServiceModeContext();

  const processTierGroup = useCallback(
    (item: SanitySystemwideTierGroup) => {
      let selectedOffer: SanitySystemwideOffer | null = null;
      if (!isUnifiedMenuEnabled && vendor) {
        selectedOffer = processTierGroup_Legacy(item, vendor, prices);
      } else if (isUnifiedMenuEnabled && indexedMenu && !isLoadingIndexedMenu) {
        selectedOffer = processTierGroup_UnifiedMenu(item, indexedMenu, posServiceMode);
      }
      return { selectedOffer };
    },
    [isUnifiedMenuEnabled, indexedMenu, isLoadingIndexedMenu, vendor, prices, posServiceMode]
  );

  return {
    processTierGroup,
  };
}
